import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getSdohCodes = (state) => allModelsSelector(state, 'SdohCode') || [];
